if (!customElements.get('product-shop-the-look')) {
  customElements.define(
    'product-shop-the-look',
    class ProductShopTheLook extends HTMLElement {
      constructor() {
        super();

        this.selections = []
        this.submitButton = this.querySelector('.js-submit')
      }

      connectedCallback() {
        this.itemsUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, (event) => {
          this.handleSelectionUpdate(event)
        })

        this.submitButton.addEventListener('click', this.handleSubmit.bind(this))
      }

       disconnectedCallback() {
        if (this.itemsUpdateUnsubscriber) {
          this.itemsUpdateUnsubscriber();
        }
      }

      handleSelectionUpdate(event) {
        this.selections = this.selections.filter(selection => selection.productId !== event.data.productId)

        if (event.data.selected) {
          this.selections.push({
            id: event.data.id,
            price: event.data.price,
            productId: event.data.productId
          })
        }

        if (this.selections.length > 0) {
          const price = this.selections.map(item => parseInt(item.price))
            .reduce((a, b) => a + b, 0)

          this.submitButton.innerHTML = `<svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22 7H1V19H22V7ZM0 6V20H23V6H0Z" fill="currentColor"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 1.5C9.29086 1.5 7.5 3.29086 7.5 5.5H6.5C6.5 2.73858 8.73858 0.5 11.5 0.5C14.2614 0.5 16.5 2.73858 16.5 5.5H15.5C15.5 3.29086 13.7091 1.5 11.5 1.5Z" fill="currentColor"/>
            </svg> &nbsp;${window.variantStrings.addToCart} - ${new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(
            price / 100,
          )}`.replace('.00', '')

          this.submitButton.disabled = false
        } else {
          this.submitButton.disabled = true
          this.submitButton.textContent = 'Select Items'
        }
      }

      async handleSubmit(e) {
        console.log(e)
        this.submitButton.disabled = true

        const items = this.selections.map(item => ({
          id: item.id,
          quantity: 1
        }))

        const body = {
          items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        }

        const response = await fetch(`/cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then(res => res.json())

        const cartDrawer = document.querySelector('cart-drawer')

        cartDrawer.classList.remove('is-empty')
        cartDrawer.renderContents(response)
      }

      getSectionsToRender() {
        return [
          {
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
        ];
      }
    }
  );
}

if (!customElements.get('shop-the-look-item')) {
  customElements.define(
    'shop-the-look-item',
    class ShopTheLookItem extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.querySelector('.js-variant-select').addEventListener('input', this.handleChange.bind(this))
        this.querySelector('.js-checkbox').addEventListener('input', this.handleSelect.bind(this))
      }

      handleChange(e) {
        const input = this.querySelector('.js-checkbox')
        input.value = e.target.value

        publish(PUB_SUB_EVENTS.selectionUpdate, {
          source: 'shop-the-look',
          data: {
            productId: input.dataset.productId,
            price: input.dataset.price,
            id: input.value,
            selected: input.checked
          }
        });
      }

      handleSelect(e) {
        const input = e.target

        publish(PUB_SUB_EVENTS.selectionUpdate, {
          source: 'shop-the-look',
          data: {
            productId: input.dataset.productId,
            price: input.dataset.price,
            id: input.value,
            selected: input.checked
          }
        });
      }
    }
  );
}
